import React from 'react';
import SourceIconSvg from '../../../../assets/source-icon.svg';
import type { SourceLink } from './parseChatSources';

type ChatSourcesProps = {
  sources: SourceLink[];
};

/** Renders source links with a small book icon, always after the message text. */
export const ChatSources = ({ sources }: ChatSourcesProps) => {
  if (sources.length === 0) {
    return null;
  }

  return (
    <div className="chatbot-sources">
      {sources.map((source, index) => (
        <div key={`${source.href}-${index}`} className="chatbot-source">
          <SourceIconSvg aria-hidden="true" />
          <a href={source.href}>{source.title}</a>
        </div>
      ))}
    </div>
  );
};
